'use client';

import AISEOPage from '@/views/products/ai-seo';

export default AISEOPage;
